import { Container } from '@hover/blueprint';
import React, { FC, useState } from 'react';
import TeamValuesSectionMobile from './TeamValuesSectionMobile';
import TeamValuesSectionDesktop from './TeamValuesSectionDesktop';
import TeamValuesButtons from './TeamValuesButtons';
import TeamValuesTablet from './TeamValuesTablet';

const TeamValuesSection: FC = () => {
  const [selectedValue, setSelectedValue] = useState<string>('think');

  const handleSelectValue = (val: string) => {
    setSelectedValue(val);
  };

  return (
    <Container
      maxW="5xl"
      overflow="hidden"
      mb={{ base: 800, tablet: 1100, desktop: 800 }}
      pb={{ base: 0, desktop: 500 }}
    >
      <TeamValuesSectionMobile
        selectedValue={selectedValue}
        setSelectedValue={handleSelectValue}
      />
      <TeamValuesSectionDesktop
        selectedValue={selectedValue}
        setSelectedValue={handleSelectValue}
      />
      <TeamValuesTablet
        selectedValue={selectedValue}
        setSelectedValue={handleSelectValue}
      />
      <TeamValuesButtons />
    </Container>
  );
};

export default TeamValuesSection;
